module.exports = __webpack_public_path__ + "images/graphic-letters@2x_f1ca1ecbb0e995cd8a85a62cb9ca3f60.png";